// Shared "is the signed-in account an app admin?" probe for the /admin
// surfaces.
//
// Presentation only — the server is still the authority and 403s every admin
// route regardless of what this returns. Its job is to stop a non-admin being
// shown a working-looking admin page whose every control dead-ends: without
// it, /admin rendered all three tiles to anyone and /admin/code-map only
// revealed the denied state AFTER a project was picked (the 403 rode in on
// the status fetch).
//
// `null` means "not known yet" — render nothing rather than flashing a denied
// state at an admin mid-load.

import { useEffect, useState } from "react";

import { fetchMe } from "../auth/useAuth";

export const useIsAdmin = (): boolean | null => {
  const [isAdmin, setIsAdmin] = useState<boolean | null>(null);

  useEffect(() => {
    let cancelled = false;
    fetchMe()
      .then((me) => {
        if (!cancelled) setIsAdmin(me?.isAdmin ?? false);
      })
      .catch(() => {
        // Probe failed — stay quiet and let the route's own 401/403 handling
        // speak. Claiming "no access" off a network blip would be a lie.
        if (!cancelled) setIsAdmin(null);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return isAdmin;
};
